/* eslint-disable no-return-assign */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import HideStyle from './styles.css';

const styles = {
  digitContainer: {
    height: '40px',
    width: '35px',
    border: '1px solid #707070',
    borderRadius: '10px',
    textAlign: 'center',
    outline: 'none',
  },
};

function OTPInput({ onOTPChange, style }) {
  const [otp, setOTP] = React.useState(Array(6).fill(''));
  const otpInputs = Array.from({ length: 6 });

  const handleChange = (e, index) => {
    let { value } = e.target;
    value = value?.replace(/\D/g, '');
    value = value?.slice(0, 1);
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);

    if (value !== '' && index < otpInputs.length - 1) {
      otpInputs[index + 1].focus();
    }
    const otpValue = newOTP.join('');
    onOTPChange(otpValue);
  };
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && index > 0 && otp[index] === '') {
      otpInputs[index - 1].focus();
    }
    if (['ArrowUp', 'ArrowDown', '-', '.', 'e', 'E'].includes(e.key)) {
      e.preventDefault();
    }
  };

  return (
    <div style={{ display: 'flex', gap: '2px' }}>
      {otpInputs.map((_, index) => (
        <input
          key={index}
          type="number"
          value={otp[index]}
          style={{ ...styles.digitContainer, ...HideStyle, ...style }}
          maxLength={1}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          onWheel={(e) => e.target.blur()}
          ref={(input) => (otpInputs[index] = input)}
        />
      ))}
    </div>
  );
}

export default OTPInput;
